import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { RequiredObjectSchema } from 'yup/lib/object'

import { ChargePoint } from '../redux/api/web-api'

import { ICapiFormInput, capiChargerDefaultValues, useCapiFormValidationSchema } from './useCapiFormValidation'
import {
    IOcppFormInput,
    useInstallationWizardValidationSchema,
    ocppChargerDefaultValues,
    useOcppFormValidationSchema,
} from './useOcppFormValidation'

const useChargePointFormValidation = (chargePoint: ChargePoint) => {
    const ocppFormValidationSchema = useOcppFormValidationSchema()
    const capiFormValidationSchema = useCapiFormValidationSchema()

    const defaultValues = chargePoint.isOcpp
        ? ocppChargerDefaultValues(chargePoint)
        : capiChargerDefaultValues(chargePoint)

    const validationSchema = chargePoint.isOcpp
        ? ocppFormValidationSchema(chargePoint)
        : capiFormValidationSchema(chargePoint, defaultValues)

    return CreateForm(validationSchema, defaultValues)
}

export const useInstallationWizardChargePointFormValidation = (chargePoint: ChargePoint) => {
    const installationWizardValidationSchema = useInstallationWizardValidationSchema()
    const capiFormValidationSchema = useCapiFormValidationSchema()

    const defaultValues = chargePoint.isOcpp
        ? ocppChargerDefaultValues(chargePoint)
        : capiChargerDefaultValues(chargePoint)

    const validationSchema = chargePoint.isOcpp
        ? installationWizardValidationSchema(chargePoint)
        : capiFormValidationSchema(chargePoint, defaultValues)

    return CreateForm(validationSchema, defaultValues)
}

const CreateForm = (validationSchema: RequiredObjectSchema, defaultValues: IOcppFormInput | ICapiFormInput) =>
    useForm<IOcppFormInput | ICapiFormInput>({
        mode: 'onChange',
        reValidateMode: 'onChange',
        delayError: 500,
        defaultValues,
        resolver: yupResolver(validationSchema),
    })

export default useChargePointFormValidation
